import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ampli } from '../../../../ampli';
import {
  IPostBumpUserSellTractorResponse,
  postBumpUserSellTractor,
} from '../../../../api/product/mutations/postBumpUserSellTractor';

interface UsePostBumpUserSellTractorMutationParams {
  onSuccess?: (bumpData: IPostBumpUserSellTractorResponse, isAutoBumped: boolean) => void;
}

export const usePostBumpUserSellTractorMutation = (params?: UsePostBumpUserSellTractorMutationParams) => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ productId, isAutoBumped }: { productId: string; isAutoBumped: boolean }) => postBumpUserSellTractor(productId),
    {
      onSuccess: (bumpData, variables) => {
        queryClient.invalidateQueries({ queryKey: ['user_sell_tractors/mine'] });
        queryClient.invalidateQueries({ queryKey: ['open_market_product_by_id'] });
        queryClient.invalidateQueries({ queryKey: ['today-sell-tractor-bump-status'] });

        if (bumpData.daysSinceLastBump !== null) {
          ampli.pvmCompleteBump({
            product_id: bumpData.sellTractorId,
            bump_times: bumpData.bumpTimes,
            days_since_last_bump: bumpData.daysSinceLastBump,
            is_auto_bumped: variables.isAutoBumped,
          });
        } else {
          ampli.pvmCompleteBump({
            product_id: bumpData.sellTractorId,
            bump_times: bumpData.bumpTimes,
            is_auto_bumped: variables.isAutoBumped,
          });
        }

        if (params?.onSuccess) {
          params.onSuccess(bumpData, variables.isAutoBumped);
        }
      },
    },
  );
};
